import api from "./api";

const leavingService = {
  // GET /api/leaving?search=&page=&limit=
  getAll: (params = {}) => api.get("/leaving", { params }),

  // GET /api/leaving/:id  (includes populated student)
  getById: (id) => api.get(`/leaving/${id}`),

  // POST /api/leaving
  create: (data) => api.post("/leaving", data),

  // PUT /api/leaving/:id
  update: (id, data) => api.put(`/leaving/${id}`, data),

  // DELETE /api/leaving/:id
  remove: (id) => api.delete(`/leaving/${id}`),
};

export default leavingService;
